export const CODE_BEIKE_1 = 'YK4352';
export const CODE_BEIKE_2 = 'BKYS01';
export const CODE_BEIKE_3 = 'F0015392';